import React from 'react'
import PropTypes from 'prop-types'

import asyncThrottler from '@scoir/async-throttler'

import { Button, Box, CircularProgress, Paper, Typography } from '@material-ui/core'
import { Alert } from '@material-ui/lab'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPaperPlane, faCheck, faCheckCircle } from '@fortawesome/pro-solid-svg-icons'

class TestConnectionStep extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  static propTypes = {
    onSendTestBatch: PropTypes.func.isRequired,
    testBatchSent: PropTypes.bool.isRequired,
    editable: PropTypes.bool.isRequired,
    needsRetest: PropTypes.bool.isRequired,
    onTestConnection: PropTypes.func,
  }

  componentDidMount() {
    this.throttler = asyncThrottler.create((state) => this.setState(state))
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.needsRetest && this.props.needsRetest) {
      this.throttler.reset()
    }
  }

  testConnection() {
    this.throttler.execute(this.props.onTestConnection())
  }

  sendTestBatch() {
    this.throttler.execute(this.props.onSendTestBatch())
  }

  getInFlightAction() {
    const { isError, isProcessed, isProcessing } = this.state
    const { testBatchSent } = this.props
    if (isProcessing) {
      return (
        <CircularProgress
          role="status"
          aria-label="Loading"
          size="25px"
        />
      )
    }
    if (isError) {
      return (
        <Alert
          severity="error"
          icon={false}
        >
          Test Connection failed. Please try again or contact support.
        </Alert>
      )
    }
    if (testBatchSent) {
      return (
        <Alert
          severity="success"
          icon={<FontAwesomeIcon icon={faCheckCircle} />}
        >
          Test Batch Sent
        </Alert>
      )
    }
    if (isProcessed) {
      return (
        <Alert
          severity="success"
          icon={<FontAwesomeIcon icon={faCheck} />}
        >
          Connected
        </Alert>
      )
    }
  }

  render() {
    const { isError, isProcessing } = this.state
    const { editable } = this.props
    let inFlightAction = null
    inFlightAction = this.getInFlightAction()
    return (
      <Paper
        component={Box}
        elevation={0}
        bgcolor={editable ? 'background.paper' : 'grey.100'}
        p={2}
        mb={2}
      >
        <Typography
          variant="h6"
          component="h5"
          gutterBottom
        >
          Step 3: Test Connection
        </Typography>
        <Typography gutterBottom>Confirm that we are able to connect to your SFTP server.</Typography>
        <Box
          display="flex"
          flexDirection={{ xs: 'column', sm: 'row' }}
          my={2}
        >
          <Box>
            <Button
              color="primary"
              variant="contained"
              disabled={!editable || isProcessing}
              onClick={() => this.testConnection()}
            >
              Test Connection
            </Button>
          </Box>
          <Box
            ml={{ xs: 0, sm: 1 }}
            mt={{ xs: 1, sm: 0 }}
          >
            <Button
              color="primary"
              variant="outlined"
              disabled={!this.props.editable || isProcessing || isError}
              onClick={() => this.sendTestBatch()}
              startIcon={<FontAwesomeIcon icon={faPaperPlane} />}
            >
              Send Test Batch
            </Button>
          </Box>
        </Box>
        <Box>{inFlightAction}</Box>
      </Paper>
    )
  }
}

export default TestConnectionStep
